import { brainStromingApp } from "./brainStromingApp";
import { CollegeChoice101 } from "./CollegeChoice101";
import { KarzounApp } from "./karzoun";
import { MantharApp } from "./MantharApp";
import { NeuraApp } from "./neura";
import { SanaideeApp } from "./Sanaidee";
import { SanaideeAdminPanel } from "./SanaideeAdminPanel";
import { SCLApp } from "./scl";
import { solveApp } from "./solveApp";
import { SoulcastApp } from "./SoulcastApp";
export const projectsData = [KarzounApp,SanaideeApp,CollegeChoice101,SCLApp,SoulcastApp,NeuraApp, SanaideeAdminPanel,brainStromingApp,MantharApp,solveApp];